import React, { useEffect } from 'react';
import usePortal from '../../hooks/usePortal';
import ReactDOM from 'react-dom';
import { TooltipContainer, Target } from './Walkthrough.styles.js';

const WithTarget = ({ target, position, children, showOverlay, border }) => {
  const targetDom = usePortal('walkthrough-target');

  useEffect(() => {
    if (targetDom) {
      targetDom.style.position = 'fixed';
      targetDom.style.zIndex = '1';
      targetDom.style.inset = '0';
    }
    return () => {
      if (targetDom) {
        targetDom.style.position = null;
        targetDom.style.zIndex = null;
        targetDom.style.inset = null;
      }
    };
  }, [targetDom]);

  if (!targetDom) return false;
  const props = target.getBoundingClientRect().toJSON();
  const { borderRadius } = window.getComputedStyle(target);
  const newProps = { ...props, borderRadius };
  return ReactDOM.createPortal(
    <>
      <Target {...newProps} showOverlay={showOverlay} />
      <Tooltip target={props} position={position} border={border}>
        {children}
      </Tooltip>
    </>,
    targetDom
  );
};

const Tooltip = ({ position, target, children, border }) => {
  const tooltipDom = usePortal('tooltip');

  if (!tooltipDom) return false;

  const spaceTooltipToTarget = 25;
  const spaceArrowToTarget = 5;
  const width = 370;

  const propsByPosition = {
    bottom: {
      top: `${target.bottom + spaceTooltipToTarget + spaceArrowToTarget}px`,
      left: `${target.left + target.width / 2 - width / 2}px`,
    },
    top: {
      bottom: `calc(100vh - ${
        target.top - spaceTooltipToTarget - spaceArrowToTarget
      }px)`,
      left: `${target.left + target.width / 2 - width / 2}px`,
    },
    left: {
      right: `calc(100vw - ${
        target.left - spaceTooltipToTarget - spaceArrowToTarget
      }px)`,
      top: `calc(${target.top + target.height / 2}px - 5%)`,
    },
    right: {
      left: `${
        target.left + target.width + spaceTooltipToTarget + spaceArrowToTarget
      }px`,
      top: `calc(${target.top + target.height / 2}px - 5%)`,
    },
    rightTop: {
      left: `${
        target.left + target.width + spaceTooltipToTarget + spaceArrowToTarget
      }px`,
      top: `calc(${target.top + 10}px - 5%)`,
    },
  };

  const align = propsByPosition[position];

  const render = () => (
    <TooltipContainer
      {...align}
      width={width}
      position={position}
      border={border}
    >
      {children}
    </TooltipContainer>
  );

  return ReactDOM.createPortal(render(), tooltipDom);
};

export default WithTarget;
